import { Box, Tab, Tabs } from "@mui/material";
import { TabPanel } from "./TabPanel/TabPanel";
import { TabPanelFilter } from "./TabPanel/TabPanelFilter";
import TabPanelNotes from "./TabPanel/TabPanelNotes";
import { useFilter } from "../../../context/FilterContext";
import { useCallback } from "react";
import { useGetFilteredNotes } from "../../../hooks/useGetFilteredNotes";

export const SearchFilter = ({ token, onSelectNota, onSelectMultipleNotas, filterState, setFilterState }) => {
  const { searchTabValue: value, setSearchTabValue: setValue, searchNotasResults, setSearchNotasResults } = useFilter();
  // PAGINACIÓN COMENTADA: cursor que indica si existen más notas por cargar.
  // const { nextCursor } = searchNotasResults || {};
  const { fetchNotas, loading } = useGetFilteredNotes(token);

  const handleSetNotas = useCallback((data) => {

    if (!data || typeof data !== 'object') {
      console.error("handleSetNotas fue llamado con datos inválidos:", data);
      return;
    }
    if (data.isNewSearch && Array.isArray(data.notes)) {
      setSearchNotasResults({
        notes: data.notes,
        nextCursor: data.nextCursor,
        totalNotes: data.totalNotes ?? data.notes.length,
        totalMedia: data.totalMedia ?? 0,
      });
    } else if (!data.isNewSearch && Array.isArray(data.notes)) {
      setSearchNotasResults(prev => {
        const newNotes = [...(prev?.notes || []), ...data.notes];
        return { ...prev, notes: newNotes, nextCursor: data.nextCursor };
      });
    }
  }, [setSearchNotasResults]);
  
  // PAGINACIÓN COMENTADA: carga de más notas (scroll infinito).
  // const handleLoadMore = useCallback(async () => {
  //   if (loading || !nextCursor) return;
  //   const filters = filterState.buildKeywordFilters ? filterState.buildKeywordFilters() : {};
  //   const result = await fetchNotas(filters, false, nextCursor);
  //   if (result && result.notes) {
  //     result.notes = result.notes.map((nota) => ({
  //       ...nota,
  //       articleWords: filterState.palabraIncluir || "",
  //     }));
  //   }
  //   handleSetNotas(result);
  // }, [loading, nextCursor, fetchNotas, handleSetNotas, filterState]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", flexShrink: 0 }}>
        <Tabs value={value} onChange={handleChange} aria-label="Tabs">
          <Tab label="Filtrado" />
          <Tab label="Notas" />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <TabPanel value={value} index={0}>
          <TabPanelFilter
            fetchNotas={fetchNotas}
            loading={loading}
            setNotas={handleSetNotas}
            setValue={setValue}
            filterState={filterState}
            setFilterState={setFilterState}
            token={token}
          />
        </TabPanel>

        {value === 1 && (
          <TabPanel value={value} index={1} style={{ height: "100%" }}>
            <TabPanelNotes
              notas={searchNotasResults?.notes || []}
              totalNotes={searchNotasResults?.totalNotes ?? searchNotasResults?.notes?.length ?? 0}
              totalMedia={searchNotasResults?.totalMedia ?? 0}
              onSelectNota={onSelectNota}
              onSelectMultipleNotas={onSelectMultipleNotas}
              // PAGINACIÓN COMENTADA: props de scroll infinito.
              // onLoadMore={handleLoadMore}
              // loadingMore={loading && !!nextCursor}
              // hasMore={!!nextCursor && filterState.modoFormulario === 'palabraClave'}
            />
          </TabPanel>
        )}
      </Box>
    </Box>
  );
};
